export const extractBounds = (metadata) => {
    let bounds = null;
    try {
        if (typeof metadata.getBounds === 'function') {
            const b = metadata.getBounds();
            if (b && typeof b.getWest === 'function') {
                bounds = {
                    west: b.getWest(),
                    south: b.getSouth(),
                    east: b.getEast(),
                    north: b.getNorth()
                };
            }
        }
    }
    catch (_) { }
    if (!bounds) {
        try {
            const metaStr = typeof metadata.getMetadata === 'function' ? metadata.getMetadata() : '';
            const metadataJson = metaStr ? JSON.parse(metaStr) : {};
            if (metadataJson && metadataJson.bounds) {
                bounds = metadataJson.bounds;
            }
        }
        catch (_) { }
    }
    return bounds;
};
export const extractRasterDimensions = (metadata) => {
    let tileWidth = 256;
    let tileHeight = 256;
    try {
        const metaStr = typeof metadata.getMetadata === 'function' ? metadata.getMetadata() : '';
        const metadataJson = metaStr ? JSON.parse(metaStr) : {};
        if (metadataJson && metadataJson.width && metadataJson.height) {
            tileWidth = metadataJson.width;
            tileHeight = metadataJson.height;
        }
    }
    catch (_) { }
    return { width: tileWidth, height: tileHeight };
};
export const getArtifactTypeName = (type) => {
    switch (type) {
        case 1: return 'Ground Overlay';
        case 2: return 'Vector Data';
        case 3: return 'Screen Overlay';
        case 4: return 'Placemark';
        case 5: return 'Info Panel';
        default: return 'Unknown';
    }
};
